module.exports = __webpack_public_path__ + "static/img/one.4271bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/6/one.png
// module id = nfRO
// module chunks = 1